//src/utils/facebook.ts

import { loadScript } from "./helpers";
export const FACEBOOK_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';

let fbInitPromise: Promise<void> | null = null;

export const initFacebookSDK = (): Promise<boolean> => {
    if (fbInitPromise) {
        return fbInitPromise.then(() => true);
    }

    fbInitPromise = new Promise((resolve, reject) => {
        // 🔑 DEFINE FIRST
        (window as any).fbAsyncInit = () => {
            (window as any).FB.init({
                appId: process.env.REACT_APP_META_APP_ID,
                cookie: true,
                xfbml: false,
                version: "v19.0",
            });

            // ensure SDK is usable
            (window as any).FB.getLoginStatus(() => {
                resolve();
            });
        };

        // 🔑 LOAD AFTER
        loadScript(FACEBOOK_SDK_URL).then((loaded) => {
            if (!loaded) reject(false);
        });
    });

    return fbInitPromise.then(() => true);
};
